import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { ContainersActions } from '../StoreAdapter'
import { ContainerSchema } from '../../../Schema/ContainerSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { ContainersAPI } from '../../../Services/API/ContainersAPI'

export const useDeleteContainer = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const deleteContainer = useCallback(
    async (schemaId: string): Promise<ContainerSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(ContainersAPI)
        .deleteEntity(schemaId)
        .then((schema) => {
          dispatch(ContainersActions.removeOne(schemaId))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err?.response?.data?.errorMessage)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    deleteContainer,
  }
}
